/**
 * Spacing CSS Rules Generator
 *
 * Generate CSS rules for spacing control group attributes.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { SpacingValues } from '../types';
import { formatSpacingValue } from '../utils';

/**
 * Generate CSS rules for spacing values
 */
export const generateSpacingCSSRules = (
	values: SpacingValues,
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Process padding
	if ( values.padding ) {
		const padding = values.padding;
		if ( padding.top ) {
			styles[ 'padding-top' ] = formatSpacingValue( padding.top );
		}
		if ( padding.right ) {
			styles[ 'padding-right' ] = formatSpacingValue( padding.right );
		}
		if ( padding.bottom ) {
			styles[ 'padding-bottom' ] = formatSpacingValue( padding.bottom );
		}
		if ( padding.left ) {
			styles[ 'padding-left' ] = formatSpacingValue( padding.left );
		}
	}

	// Process margin
	if ( values.margin ) {
		const margin = values.margin;
		if ( margin.top ) {
			styles[ 'margin-top' ] = formatSpacingValue( margin.top );
		}
		if ( margin.right ) {
			styles[ 'margin-right' ] = formatSpacingValue( margin.right );
		}
		if ( margin.bottom ) {
			styles[ 'margin-bottom' ] = formatSpacingValue( margin.bottom );
		}
		if ( margin.left ) {
			styles[ 'margin-left' ] = formatSpacingValue( margin.left );
		}
	}

	return styles;
};
